import { Stack } from "@mui/material";
import { TextInput } from "@src/appV2/redesign/components/TextInput";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type CredentialsFormData } from "../api/schema";

interface TimeclockPinPlusPasswordCredentialsProps {
  register: UseFormRegister<CredentialsFormData>;
  errors: FieldErrors<CredentialsFormData>;
}

export function TimeclockPinPlusPasswordCredentials({
  register,
  errors,
}: TimeclockPinPlusPasswordCredentialsProps) {
  return (
    <Stack spacing={2}>
      <TextInput
        fullWidth
        label="Time Clock Pin"
        error={Boolean(errors.timeclockPin)}
        helperText={errors.timeclockPin?.message}
        inputProps={{ "data-dd-privacy": "mask" }}
        {...register("timeclockPin")}
      />
      <TextInput
        fullWidth
        label="Time Clock Password"
        error={Boolean(errors.timeclockPassword)}
        helperText={errors.timeclockPassword?.message}
        inputProps={{ "data-dd-privacy": "mask" }}
        {...register("timeclockPassword")}
      />
    </Stack>
  );
}
